{
  "version": "v4.2.5",
  "name": "AlphStakeAndLock",
  "bytecodeTemplate": "01010300020018b417001600{2}a2{2}0d0c{0}010c0c0d{1}010c170116001601{2}a3{2}0d0c{1}010f",
  "fieldsSig": {
    "names": [
      "xAlphToken",
      "xAlphStakeVault",
      "amount"
    ],
    "types": [
      "XAlphToken",
      "XAlphStakeVault",
      "U256"
    ],
    "isMutable": [
      false,
      false,
      false
    ]
  },
  "functions": [
    {
      "name": "main",
      "paramNames": [],
      "paramTypes": [],
      "paramIsMutable": [],
      "returnTypes": []
    }
  ]
}